import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import MinecraftItemBuilder from "./MinecraftItemBuilder";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <MinecraftItemBuilder />
  </StrictMode>
);
